import { Component, Input } from '@angular/core';
import { DynamicTabsService } from './dynamic-tabs.service';
import { SideNavToggle } from './shared/sidenav-toggle.model';
import { navbarData } from './sidenav/nav-data';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HomeService } from './services/homeservice';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'outdoor';

  constructor(public dynamicTabsService: DynamicTabsService, private actRoute: ActivatedRoute, private service: HomeService) {
    sessionStorage.clear();
  }

}
